"use strict";
// This file fixes a memory leak in the `textmacros` package. See this issue:
// https://github.com/mathjax/MathJax/issues/3061
// TODO(benchristel): remove this after upgrading to MathJax 4.
Object.defineProperty(exports, "__esModule", { value: true });
const TextParser_1 = require("mathjax-full/js/input/tex/textmacros/TextParser");
Object.assign(TextParser_1.TextParser.prototype, {
    _mml: TextParser_1.TextParser.prototype.mml,
    mml() {
        this.configuration.clear();
        return this._mml();
    },
});
